// modal.ts
export class Modal {
    private body: HTMLElement;
    private dialog: HTMLDialogElement;
    private contentElement: HTMLElement | null;
    private closeButton: HTMLButtonElement | null;
    private handleOutsideClick: (event: MouseEvent) => void;

    constructor(dialog: HTMLDialogElement) {
        this.body = document.body;
        this.dialog = dialog;
        this.contentElement = dialog.querySelector<HTMLElement>('[data-modal-content]');
        this.closeButton = dialog.querySelector<HTMLButtonElement>('[data-modal-close]');

        this.closeButton?.addEventListener('click', () => this.close());

        this.handleOutsideClick = (event: MouseEvent) => {
            if (!this.contentElement) return;

            if (!this.contentElement.contains(event.target as Node)) {
                this.close();
            }
            if (event.target === this.contentElement) {
                this.close();
            }
        };

        document.addEventListener('keydown', (event) => this.handleEscapeKey(event));
    }

    open(content?: string) {
        if (content && this.contentElement) {
            this.contentElement.innerHTML = content;
        }
        this.dialog.showModal();
        this.dialog.classList.add('shown');
        this.dialog.addEventListener('click', this.handleOutsideClick);
        this.body.classList.add('overflow-hidden');
    }

    close() {
        this.dialog.close();
        this.dialog.classList.remove('shown');
        this.dialog.removeEventListener('click', this.handleOutsideClick);
        this.body.classList.remove('overflow-hidden');
    }

    private handleEscapeKey(event: KeyboardEvent): void {
        if (event.key === 'Escape') {
            this.close();
        }
    }
}

// initializer ---
export function initModals(): void {
    const triggers = document.querySelectorAll<HTMLButtonElement>('[data-modal-target]');

    triggers.forEach((trigger) => {
        const targetSelector = trigger.dataset.modalTarget;
        if (!targetSelector) return;

        const dialog = document.querySelector<HTMLDialogElement>(targetSelector);
        if (!dialog) return;

        const modal = new Modal(dialog);

        trigger.addEventListener('click', () => {
            modal.open(trigger.dataset.content);
        });
    });
}
